module.exports = __webpack_public_path__ + "img/chivas_crystalgold_age.7a66a2db.jpg";